export default __webpack_public_path__ + "static/media/vox-img-legacy-016.bac211c2.jpg";